import React, { useState, useEffect } from 'react';
import './Challenge.css';
import { CSVLink } from 'react-csv';
import { useUser } from '../context/UserContext';
import Select from 'react-select';
import { FiChevronDown,FiRefreshCw  } from 'react-icons/fi';

const PlayTrailReport = () => {
  const { selectedCenter, setSelectedCenter, userData } = useUser();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedAcademy, setSelectedAcademy] = useState('');
  const getFormattedDate = (date) => date.toISOString().split('T')[0];
  const today = new Date();
  const tenDaysAgo = new Date();
  const token = localStorage.getItem('auth-token');
  tenDaysAgo.setDate(today.getDate() - 10);
  const [fromDate, setFromDate] = useState(getFormattedDate(tenDaysAgo));
  const [toDate, setToDate] = useState(getFormattedDate(today));
  const [PlayTrail, setPlayTrail] = useState([]);
  const [academyMap, setAcademyMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // useEffect(() => {
  //   if (selectedCenter && academyMap[selectedCenter]) {
  //     setSelectedAcademy(selectedCenter);
  //   }
  // }, [selectedCenter, academyMap]);

    const fetchData = async () => {
      if (selectedAcademy === null || selectedAcademy === undefined) {
        setPlayTrail([]);
        setError("Please select an academy.");
        return;
      }

      setLoading(true);
      setError("");
      setPlayTrail([]);

      try {
        let apiUrl = process.env.REACT_APP_API_ACADEMY_PLAY_TRIALS;
        if (userData?.userType === "ACADEMY" && userData.academyIds?.length > 0) {
          const academyIdsString = userData.academyIds.join(",");
          apiUrl += `?academyIds=${academyIdsString}`;
        }

        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({
            fromDate: fromDate,
            toDate: toDate,
            academyId: selectedAcademy || null,
          }),
        });

        const responseText = await response.text();
        if (!responseText) {
          setError("No data available");
          return;
        }

        let data;
        try {
          data = JSON.parse(responseText);
        } catch (jsonError) {
          setError("Received invalid data from server");
          return;
        }

        if (!response.ok) {
          throw new Error(data.message || `HTTP error! Status: ${response.status}`);
        }

        if (data.success) {
          const academyMap = data.data?.academyNameMap || {};
          setAcademyMap(academyMap);

          const bookings = data.data?.bookings?.map((booking) => ({
            name: booking.name,
            phone: booking.contact,
            court: booking.courtName,
            date: new Date(booking.bookingDate).toLocaleDateString(),
            time: booking.bookingTime,
          })) || [];

          setPlayTrail(bookings);

          if (bookings.length === 0) {
            setError("No bookings found for the selected criteria");
          }
        } else {
          setError(data.success_message || "No data available");
        }
      } catch (error) {
        setError(error.message || "Error fetching data. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
    fetchData();
  }, [selectedAcademy, fromDate, toDate]);

  const headers = [
    { key: 'name', label: 'Name' },
    { key: 'phone', label: 'Phone' },
    { key: 'court', label: 'Court' },
    { key: 'date', label: 'Date' },
    { key: 'time', label: 'Time' },
  ];

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedAcademy, fromDate, toDate]);

  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);

  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredPlayTrail = PlayTrail.filter((play) => {
    const matchesSearch = Object.values(play)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase());


    return matchesSearch;
  });

  const sortedPlayTrail = React.useMemo(() => {
    let sortableItems = [...filteredPlayTrail];
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [filteredPlayTrail, sortConfig]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedPlayTrail.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredPlayTrail.length / rowsPerPage);

  const handleSort = (column) => {
    let direction = 'asc';
    if (sortConfig.key === column && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: column, direction });
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const totalEntries = filteredPlayTrail.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  const academyOptions = Object.entries(academyMap)
    .filter(([academyId]) =>
      userData?.userType === "ACADEMY" ? userData.academyIds.includes(Number(academyId)) : true
    )
    .map(([value, label]) => ({
      value,
      label,
    }));

  return (
      <div className="enrollment-container">
        <div className="sales-filters-login">
  
          <div className="floating-select">
            <Select
              id="selectedAcademy"
              className={`sales-filter-court-booking ${selectedAcademy ? "has-value" : ""}`}
              classNamePrefix="select"
              options={academyOptions}
              value={academyOptions.find(option => option.value === selectedAcademy)}
              onChange={(selectedOption) => {
                setSelectedAcademy(selectedOption ? selectedOption.value : '');
              }}
              placeholder="Select Academy"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                placeholder: (provided) => ({
                  ...provided,
                  color: 'black',
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
            />
          </div>
  
          <div className="floating-select">
            <input
              type="date"
              className={`sales-filter-academy ${fromDate ? "has-value" : ""}`}
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              onClick={(e) => e.target.showPicker()}
              max={new Date().toISOString().split('T')[0]}
            />
            {fromDate && <label htmlFor="fromDate">Start Date</label>}
          </div>
  
          <div className="floating-select">
            <input
              type="date"
              className={`sales-filter-academy ${toDate ? "has-value" : ""}`}
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              onClick={(e) => e.target.showPicker()}
              max={new Date().toISOString().split('T')[0]}
            />
            {toDate && <label htmlFor="toDate">End Date</label>}
          </div>
        </div>
        <div className="search-bar">
          <div className="input-container">
            <input
              type="text"
              id="searchInput"
              placeholder=""
              className={`search-input ${searchTerm ? "has-value" : ""}`}
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <label htmlFor="searchInput" className="floating-label">
              🔍 Search
            </label>
          </div>
          <CSVLink
            data={filteredPlayTrail.map(({ phone, ...rest }) => rest)}
            headers={headers.filter(header => header.key !== 'phone')}
            filename="PlayTrialReport.csv"
            className="btn btn-primary no-decoration"
          >
            <button className="csv_button" type="button" >
              <span
                className="button__text"
  
              >
                Export CSV
              </span>
              <span className="button__icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                  <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                  <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                  <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
                </svg>
              </span>
            </button>
          </CSVLink>
        </div>
  
        <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchData}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>

      </div>
  
        {loading && (
          <div className="premium-loader">
            <div className="progress-track">
              <div className="progress-bar"></div>
            </div>
            <div className="status-text">
              <span>L</span>
              <span>O</span>
              <span>A</span>
              <span>D</span>
              <span>I</span>
              <span>N</span>
              <span>G</span>
            </div>
          </div>
        )}
        {error && <div className="error-message">{error}</div>}
        {!loading && !error && filteredPlayTrail.length === 0 && (
          <div className="error-message">No data available</div>
        )}
  
        
        <div className="tt-table-container">
          <table className="tt-table">
            <thead>
              <tr className="challenges-header-row">
                {headers.map(({ key, label }) => (
                  <th
                    key={key}
                    className="challenges-column"
                    onClick={() => handleSort(key)}
                  >
                    <div className="th-content">
                      <span>{label}</span>
                      <FiChevronDown
                        className={`sort-icon 
                ${sortConfig.key === key ? 'active' : ''} 
                ${sortConfig.key === key && sortConfig.direction === 'asc' ? 'asc' : ''} 
                ${sortConfig.key === key && sortConfig.direction === 'desc' ? 'desc' : ''}`}
                      />
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
  
  
  
            <tbody>
              {currentRows.map((play) => (
                <tr key={play.id} >
                  <td>{play.name}</td>
                  <td>{play.phone}</td>
                  <td>{play.court}</td>
                  <td>{play.date}</td>
                  <td>{play.time}</td>
                </tr>
              ))}
            </tbody>
  
          </table>
        </div>
  
        <div className="pagination">
          <div className="showing-entries">
            Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
          </div>
          <button
            className="prev-button"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {renderPagination()}
          <button
            className="next-button"
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    );
  };
  
  export default PlayTrailReport
  